import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { toast } from '@grandvisionhq/common';
import '../../models/adyen/payment-type.js';
import { PaymentMethod, PaymentServiceProvider } from '../../models/cart-payment-methods/cart-payment-methods.js';
import '../../models/googlePay/types.js';
import '../../models/payment/types.js';
import '../../models/paypal/context.js';
import { useCreateApplePaySession } from './use-create-apple-pay-session.js';

var UseApplePayError;
(function(UseApplePayError) {
    UseApplePayError["UNSUPPORTED"] = "UNSUPPORTED";
    UseApplePayError["CANCELLED"] = "CANCELLED";
    UseApplePayError["FAILED"] = "FAILED";
})(UseApplePayError || (UseApplePayError = {}));
var ShippingContactEditingMode;
(function(ShippingContactEditingMode) {
    ShippingContactEditingMode["STORE_PICKUP"] = 'storePickup';
    ShippingContactEditingMode["DEFAULT"] = 'enabled';
})(ShippingContactEditingMode || (ShippingContactEditingMode = {}));
const ApplePaySessionErrors = {
    ApplePaySessionUnsupported: 'checkout.express.apple.pay.errors.unsupported',
    ApplePaySessionFailed: 'checkout.express.apple.pay.errors.failed',
    ApplePayPaymentFailed: 'checkout.express.apple.pay.errors.payment.failed',
    ApplePayInvalidAddress: 'checkout.express.apple.pay.errors.invalid.address'
};
const useApplePayWithActions = ({ isExpressPayment =true ,  } = {})=>{
    const [error, setError] = React.useState();
    const { createApplePaySession  } = useCreateApplePaySession();
    const payCartWithApplePayActions = React.useCallback(({ createPaymentRequest , completePayment , validations , saveCustomerDetails , disableShippingFormUpdate =true  })=>{
        if (typeof ApplePaySession === 'undefined' && error !== UseApplePayError.UNSUPPORTED) {
            console.error('Apple pay can only be used on Safari.');
            setError(UseApplePayError.UNSUPPORTED);
            toast.failed(ApplePaySessionErrors.ApplePaySessionUnsupported);
            return null;
        }
        const paymentRequest = createPaymentRequest();
        if (!paymentRequest) {
            return null;
        }
        const session = new ApplePaySession(12, swcHelpers.objectSpread({}, paymentRequest, disableShippingFormUpdate ? {
            shippingContactEditingMode: undefined,
            shippingType: undefined,
            requiredBillingContactFields: undefined,
            requiredShippingContactFields: undefined
        } : {}));
        session.onvalidatemerchant = ()=>{
            /**
         * Abort operation if apple pay session creation fails
         * Create hook in payments package to make BE call and return session
         */ createApplePaySession(session);
        };
        session.onshippingcontactselected = (e)=>{
            if ((validations === null || validations === void 0 ? void 0 : validations.shippingData) && !validations.shippingData(e, session, paymentRequest)) {
                return;
            }
            session.completeShippingContactSelection({
                newTotal: paymentRequest.total
            });
            return;
        };
        session.onpaymentauthorized = function() {
            var _ref = swcHelpers.asyncToGenerator(function*(e) {
                if (isExpressPayment && (validations === null || validations === void 0 ? void 0 : validations.paymentData) && !validations.paymentData(e, session)) {
                    return;
                }
                const applePayToken = btoa(JSON.stringify(e.payment.token.paymentData));
                try {
                    saveCustomerDetails && (yield saveCustomerDetails());
                    yield completePayment({
                        shippingData: e.payment.shippingContact,
                        billingData: e.payment.billingContact,
                        paymentToken: applePayToken,
                        selectedPaymentMethod: {
                            type: PaymentMethod.APPLE_PAY,
                            provider: PaymentServiceProvider.ADYEN
                        }
                    });
                    session.completePayment(ApplePaySession.STATUS_SUCCESS);
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                } catch (e1) {
                    session.completePayment(ApplePaySession.STATUS_FAILURE);
                }
            });
            return function(e) {
                return _ref.apply(this, arguments);
            };
        }();
        session.oncancel = ()=>{
            try {
                session.abort();
            } catch (e) {
                // Swallow InvalidAccessError
                if (!(e instanceof Error && e.name === 'InvalidAccessError')) {
                    throw e;
                }
            }
        };
        session.begin();
        return session;
    }, [
        createApplePaySession,
        error,
        isExpressPayment
    ]);
    return [
        payCartWithApplePayActions
    ];
};

export { ApplePaySessionErrors, UseApplePayError, useApplePayWithActions };
//# sourceMappingURL=use-apple-pay-with-actions.js.map
